import { GraphQLError } from 'graphql';

export class MockRateLimitedGraphQLError extends GraphQLError {
  constructor() {
    super('Too many requests.', [], [] as any, [], [], [] as any, {
      code: 'RATE_LIMITED',
    });
  }
}
